export default __webpack_public_path__ + "static/media/icondt.83f37571.png";